import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useConfirmStore = defineStore('confirm', () => {
  const key = ref('')
  const header = ref('')
  const text = ref('')
  const confirmBtn = ref<'delete' | 'okay' | 'discard' | 'remove'>('delete')
  const variant = ref<'default' | 'destructive'>()
  const isOpen = ref(false)

  const open = (
    _key: string,
    _header: string,
    _text: string,
    _confirmBtn: 'delete' | 'okay' | 'discard' | 'remove',
    _variant: 'default' | 'destructive' | undefined = 'destructive'
  ) => {
    key.value = _key
    header.value = _header
    text.value = _text
    confirmBtn.value = _confirmBtn
    variant.value = _variant
    isOpen.value = true
  }

  const confirm = () => {
    isOpen.value = false
  }

  const cancel = () => {
    isOpen.value = false
  }

  return {
    key,
    header,
    text,
    confirmBtn,
    variant,
    isOpen,
    open,
    confirm,
    cancel
  }
})
